import React, { Component, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import useStateRef from 'react-usestateref';

export const CbCsoProfile = ({ containerObject, templateName, contentId, dataZone }) => {
    const [pwd, setPwd] = useState('');
    const [isRevealPwd, setIsRevealPwd] = useState(false);
    const [confirmPwd, setConfirmPwd] = useState('');
    const [isRevealConfirmPwd, setIsRevealConfirmPwd] = useState(false);
    const [tAndC, setTandC] = useState("false");
    const [optIn, setOptIn] = useState("true");
    const [registerError, setRegisterError] = useState("");
    const [postAuthUrl, setPostAuthUrl] = useState();
    const [id, setId] = useState();
    const [firstName, setFirstName, firstNameRef] = useStateRef();
    const [lastName, setLastName, lastNameRef] = useStateRef();
    const [isImported, setIsImported, isImportedRef] = useStateRef();
    const [generatedPassword, setGeneratedPassword, generatedPasswordRef] = useStateRef();
    const [email, setEmail, emailRef] = useStateRef();
    const [token, setToken] = useState();
    const [domain, setDomain] = useState();
    useEffect(() => {
        setDomain(containerObject && containerObject.csoLogoImageUrl)
        var searchParam = window.location.search
        const params = new URLSearchParams(searchParam);
        var id = params.get("id")
        setId(id)
        setPostAuthUrl(params && params.get("goto"))
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/get-sso-profile-data/${id}`, {
            method: 'GET',
            headers: new Headers({
                "content-Type": "application/json",
            })
        }).then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                    setFirstName(JSON.parse(res.response).firstName)
                    setLastName(JSON.parse(res.response).lastName)
                    setEmail(JSON.parse(res.response).email)
                    setIsImported(JSON.parse(res.response).isImported)
                    setGeneratedPassword(JSON.parse(res.response).generatedPassword)

                } else {

                }
            })
    }, [])
    const handleOptIn = () => {
        if (optIn == "true") {
            setOptIn("false")
        } else {
            setOptIn("true")
        }
    }

    const handleCallBack = () => {
        document.getElementById("sso-profile-redirect").click();
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        var actionUrl = event.target.getAttribute('action');
        var formData = new FormData(event.target);
        const formValue = Object.fromEntries(formData.entries());
        formValue["tAndC"] = tAndC
        formValue["optIn"] = optIn
        formValue["updateSuccessURL"] = "/account/sso/profile.jsp"
        formValue["updateErrorURL"] = "/account/sso/profile.jsp"
        formValue["postAuthUrl"] = postAuthUrl
        formValue["profileId"] = id
        document.getElementById("sso-reg-error").classList.remove("d-block")
        document.getElementById("sso-reg-error").classList.add("d-none")
        document.getElementById("firstName_cso-profile-error").classList.remove("d-block");
        document.getElementById("firstName_cso-profile-error").classList.add("d-none");
        document.getElementById("cso-profile-firstName").classList.remove("form-error");
        document.getElementById("lastName_cso-profile-error").classList.remove("d-block");
        document.getElementById("lastName_cso-profile-error").classList.add("d-none");
        document.getElementById("cso-profile-lastName").classList.remove("form-error");
        document.getElementById("email_cso-profile-error").classList.remove("d-block");
        document.getElementById("email_cso-profile-error").classList.add("d-none");
        document.getElementById("cso-profile-email").classList.remove("form-error");
        document.getElementById("password_cso-profile-error").classList.remove("d-block");
        document.getElementById("password_cso-profile-error").classList.add("d-none");
        document.getElementById("cso-profile-password").classList.remove("form-error");
        document.getElementById("confirmPassword_cso-profile-error").classList.remove("d-block");
        document.getElementById("confirmPassword_cso-profile-error").classList.add("d-none");
        document.getElementById("cso-profile-confirmPassword").classList.remove("form-error");
        document.getElementById("tAndC_cso-profile-error").classList.remove("d-block");
        document.getElementById("tAndC_cso-profile-error").classList.add("d-none");
        document.getElementById("optIn_cso-profile-error").classList.remove("d-block");
        document.getElementById("optIn_cso-profile-error").classList.add("d-none");
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/${actionUrl}`, {
            method: 'POST',
            headers: new Headers({
                "content-Type": "application/json",
            }),
            body: JSON.stringify({ data: formValue })
        }).then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                    const response = res.response && res.response.response;
                    const token = response && response.token
                    console.log("profile-token", token)
                    setToken(token);
                    if (postAuthUrl) {
                        handleCallBack();
                    }
                } else {
                    var responseObj = res.response
                    handleRegistrationMessage(responseObj.errorMessage)
                }
            })
    }
    function handleRegistrationMessage(errorList) {
        console.log("errorList", errorList)
        document.getElementById("sso-reg-error").classList.remove("d-none");
        document.getElementById("sso-reg-error").classList.add("d-block");
        errorList && errorList.map((item, index) => {
            if (item.key != "tAndC" && item.key != "optIn") {
                document.getElementById("cso-profile-".concat(item.key)).classList.add("form-error")
            }
            if (item.message != "hidden") {
                var html = document.getElementById(item.key.concat("_cso-profile-error")).innerHTML
                if (html) {
                    document.getElementById(item.key.concat("_cso-profile-error")).innerHTML = html + "</br>" + item.message;
                } else {
                    document.getElementById(item.key.concat("_cso-profile-error")).innerHTML = item.message;
                }
                document.getElementById(item.key.concat("_cso-profile-error")).classList.remove("d-none");
                document.getElementById(item.key.concat("_cso-profile-error")).classList.add("d-block");
            }
        });
    }

    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content c-shop-list-detail`}>
            <div class="c-container bg-white">
                <div class="row justify-content-center cso-pages px-md-2">
                    <div class="row">
                        <div class="col-md-12">
                            <a href={domain} class="c-cso-logo">
                                <img src="/images/cso-logo.jpg" alt="Carolina Science Online" />
                            </a>
                        </div>
                        <hr />
                    </div>
                    <form method="post" action="SSO-updateprofile" id="updateSSO" data-hs-cf-bound="true" onSubmit={handleSubmit}>

                        <div class="row">
                            <div class="col-md-12">
                                <h1 class="c-account-list-heading mb-2">My Profile</h1>
                                <p>
                                    If you need to make changes to your profile information, adjust as necessary and click <strong>Update Profile</strong> to save your changes.
                                </p>
                                <div className="alert alert-danger d-none" role="alert" id="sso-reg-error">
                                    <div id='firstName_cso-profile-error' className='d-none text-dark'></div>
                                    <div id='lastName_cso-profile-error' className='d-none text-dark'></div>
                                    <div id='email_cso-profile-error' className='d-none text-dark'></div>
                                    <div id='confirmPassword_cso-profile-error' className='d-none text-dark'></div>
                                    <div id='password_cso-profile-error' className='d-none text-dark'></div>
                                    <div id='tAndC_cso-profile-error' className='d-none text-dark'></div>
                                    <div id='optIn_cso-profile-error' className='d-none text-dark'></div>
                                </div>
                                <div class="mb-3 row">
                                    <label for="staticEmail" class="col-sm-3 col-form-label fw-bold">Name: *</label>
                                    <div class="col-sm-3 mb-3 mb-md-0">
                                        <input maxlength="19" name="firstName" id="cso-profile-firstName" placeholder="First Name" type="text" readOnly value={firstNameRef.current ? firstNameRef.current : ""} class="form-control" />
                                    </div>
                                    <div class="col-sm-3 mb-3 mb-md-0">
                                        <input maxlength="19" name="lastName" id="cso-profile-lastName" placeholder="Last Name" type="text" readOnly value={lastNameRef.current ? lastNameRef.current : ""} class="form-control" />
                                    </div>
                                </div>
                                <hr />
                                <div class="mb-3 row">
                                    <label for="staticEmail" class="col-sm-3 col-form-label fw-bold">Email: *</label>
                                    <div class="col-sm-6">
                                        <input maxlength="256" name="previousEmail" id="cso-profile-email" type="text" readOnly value={emailRef.current ? emailRef.current : ""} class="form-control mb-4" />
                                        <div class="form-check">
                                            <input name="optIn" id="cso-profile-optIn" defaultChecked onClick={handleOptIn} type="checkbox" className="form-check-input" />
                                            <label className="form-check-label" for="flexCheckChecked">
                                                Yes, sign me up for relevant tips and how tos.
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div class="mb-3 row my-2" style={{ position: 'relative' }}>
                                    <label for="inputPassword" className="col-sm-3 col-form-label fw-bold">New Password: *</label>
                                    <div class="col-sm-3 position-relative">
                                        <input name="password" id="cso-profile-password" type={isRevealPwd ? "text" : "password"} className="form-control" value={pwd} onChange={e => setPwd(e.target.value)} />
                                        <Link class="cso-password-show" style={{ position: 'absolute' }} id="show-password" onClick={() => setIsRevealPwd(prevState => !prevState)}>
                                            {isRevealPwd ? 'HIDE' : 'SHOW'}
                                        </Link>
                                    </div>
                                    <div class="col-sm-6">
                                        <p class="m-0">
                                            Passwords must be at least 6 characters long.
                                        </p>
                                    </div>
                                </div>
                                <div class="mb-3 row my-2">
                                    <label for="inputPassword" className="col-sm-3 col-form-label fw-bold">Confirm New Password: *</label>
                                    <div class="col-sm-3 position-relative">
                                        <input name="confirmPassword" id="cso-profile-confirmPassword" type={isRevealConfirmPwd ? "text" : "password"} className="form-control" value={confirmPwd} onChange={e => setConfirmPwd(e.target.value)} />
                                        <Link class="cso-password-show" style={{ position: 'absolute' }} id="show-password" onClick={() => setIsRevealConfirmPwd(prevState => !prevState)}>
                                            {isRevealConfirmPwd ? 'HIDE' : 'SHOW'}
                                        </Link>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 col-md-12 text-end">
                                <input name="updateSSO" type="submit" value="Update Profile" class="btn btn-primary btn-block" />
                            </div>
                        </div>
                    </form>
                    <form method="post" action={postAuthUrl} className="d-none">
                        <input type="hidden" id="createdToken" name="createdToken" value={token} />
                        <input type="submit" id="sso-profile-redirect" />
                    </form>
                </div>
            </div>
        </div>
    )
}
